// components/admin/main/LibraryCatalogBannerAdmin.jsx
import { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import css from "./LibraryOffersAdmin.module.css";

const defaultData = {
  bannerText:
    "Час майстрів кожні півроку створює електронний каталог книжок видавництва Час майстрів.",
  buttonText: "Відкрити каталог для бібліотек",
  linkUrl: "",
  active: true,
};

export default function LibraryCatalogBannerAdmin() {
  const [form, setForm] = useState(defaultData);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const docRef = doc(db, "siteContent", "libraryCatalogBanner");

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          setForm({ ...defaultData, ...snap.data() });
        } else {
          setForm(defaultData);
        }
      } catch (err) {
        console.error("Помилка завантаження банера каталогу:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await setDoc(docRef, form, { merge: true });
      alert("Банер каталогу збережено");
    } catch (err) {
      console.error("Помилка збереження банера каталогу:", err);
      alert("Помилка при збереженні. Перевір консоль.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className={css.wrap}>
        <p>Завантаження...</p>
      </div>
    );
  }

  return (
    <div className={css.wrap}>
      <h2>Банер каталогу для бібліотек</h2>

      <form onSubmit={handleSubmit} className={css.form}>
        <label>
          Текст на банері
          <textarea
            name="bannerText"
            value={form.bannerText}
            onChange={handleChange}
            rows={4}
            required
          />
        </label>

        <label>
          Текст кнопки
          <input
            name="buttonText"
            value={form.buttonText}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Посилання на каталог
          <input
            name="linkUrl"
            value={form.linkUrl}
            onChange={handleChange}
            placeholder="https://..."
            required
          />
        </label>

        <label className={css.checkboxRow}>
          <input
            type="checkbox"
            name="active"
            checked={form.active}
            onChange={handleChange}
          />
          Активний банер
        </label>

        <div className={css.buttons}>
          <button type="submit" disabled={saving}>
            Зберегти банер
          </button>
        </div>
      </form>
    </div>
  );
}
